function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M12 3c.245 0 .45.177.492.41l.008.09v2.019c3.192.243 5.739 2.79 5.981 5.982L20.5 11.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008h-2.019c-.243 3.191-2.79 5.738-5.98 5.981L12.5 20.5c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41l-.008-.09v-2.019c-3.19-.242-5.738-2.79-5.981-5.98L3.5 12.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492l.09-.008h2.019C5.76 8.31 8.309 5.762 11.5 5.52L11.5 3.5c0-.276.224-.5.5-.5zm0 3.5c-3.038 0-5.5 2.462-5.5 5.5s2.462 5.5 5.5 5.5 5.5-2.462 5.5-5.5-2.462-5.5-5.5-5.5zM12 9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z"
});

var SvgIconLocateActive = function SvgIconLocateActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLocateActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-locate-active.4c28334a.svg";
export { ForwardRef as ReactComponent };